import { ThunkDispatch } from "@reduxjs/toolkit";
import { clearStorage } from "./clearStorage";
import history from "./history";

export default function logout(dispatch: ThunkDispatch<any, any, any>) {
  clearStorage(dispatch);
  history.push("/login");
}
